var chunkMapping = {
	"2080": [
		8954
	],
	"3034": [
		3034
	],
	"8594": [
		8594
	]
};
var idToExternalAndNameMapping = {
	"3034": [
		"default",
		"./useBenefitUsages",
		6435
	],
	"8594": [
		"default",
		"./HeaderHomeNotification",
		5277
	],
	"8954": [
		"default",
		"./useLegacyCurrentAccountContracts",
		877
	]
};
var idToRemoteMap = {
	"3034": [
		{
			"externalType": "script",
			"name": "contract",
			"externalModuleId": 6435
		}
	],
	"8594": [
		{
			"externalType": "script",
			"name": "notification",
			"externalModuleId": 5277
		}
	],
	"8954": [
		{
			"externalType": "script",
			"name": "contractLegacy",
			"externalModuleId": 877
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}